import { useCallback } from 'react';
import merge from 'lodash/merge';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import LexicalEditor from '@/components/LexicalEditor';

import useTaskInstructionEditor from './hooks/useTaskInstructionEditor';
import { TaskDetailsInstructionProps } from './types';

const DEFAULT_CLASSES: TaskDetailsInstructionProps['classes'] = {
  container:
    'mt-4 border border-solid border-transparent focus-within:border-focus-primary p-8 rounded-8',
  editor: 'px-8 body-long-01 text-text-paragraph',
};

const TaskDetailsInstruction = (props: TaskDetailsInstructionProps) => {
  const { uppy, editorProps, onEditorBlur } = useTaskInstructionEditor(props);
  const { t } = useTranslation('Task');

  const handleEditorUpdate = useCallback(
    (data: { text: string; media: any[] }) => {
      props.onChange({ text: data.text, medias: [] });
    },
    [props],
  );

  const classes = merge(Object.assign({}, DEFAULT_CLASSES), props.classes);

  return (
    <Stack className="w-full relative" direction="col">
      <LexicalEditor
        autoSave={true}
        debouncedDuration={props.debouncedDuration}
        placeholder={`${t('Task:AddDescription')}...`}
        value={props.value?.text || ''}
        onUpdate={handleEditorUpdate}
      />
    </Stack>
  );
};

export default TaskDetailsInstruction;
